import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import ArtworkCard from "../components/ArtworkCard";
import Seo, { usePageSeo } from "../lib/seo";

export default function Portfolio() {
  const [works, setWorks] = useState(null);
  const pageSeo = usePageSeo("portfolio");

  useEffect(() => {
    api.get("/portfolio").then((r) => setWorks(r.data)).catch(() => setWorks([]));
  }, []);

  return (
    <main data-testid="portfolio-page" className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-20 pt-40 md:pt-52 pb-16">
      <Seo title={pageSeo?.seo_title} description={pageSeo?.seo_description}
        canonical={`${window.location.origin}/portfolio`} image={works?.[0]?.eff_og_image} />
      <header className="border-b hairline pb-8 mb-14">
        <div className="label mb-6">Selected Works</div>
        <h1 className="font-display font-800 uppercase leading-[0.9] tracking-[-0.02em] text-6xl md:text-8xl">Portfolio</h1>
        <p className="mt-8 text-[var(--muted)] max-w-xl">
          A curated selection drawn from the RCKT Archive. Every work here remains part of the complete archive.
        </p>
      </header>

      {works === null ? (
        <div className="py-24 label">Loading…</div>
      ) : works.length === 0 ? (
        <div className="py-32 max-w-xl" data-testid="portfolio-empty">
          <div className="label mb-4">Nothing selected yet</div>
          <p className="text-[var(--muted)] text-lg leading-relaxed">
            The portfolio is currently being curated. In the meantime, the complete body of work lives in the{" "}
            <Link to="/archive" className="underline hover:opacity-60 transition-opacity">Archive</Link>.
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
          {works.map((a, i) => (
            <ArtworkCard key={a.slug} art={a} index={i} />
          ))}
        </div>
      )}
    </main>
  );
}
